export default "__VITE_ASSET__DHTrz7iH__"